import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useLinkInvoice = (invoiceId: string, receiptId: string) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.put(api.linkInvoice(receiptId), undefined, {
        params: { invoiceId },
      });
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, [invoiceId, receiptId]);

  const { isLoading, execute } = useAsync(call, false);

  return { isLoading, linkInvoice: execute };
};

export default useLinkInvoice;
